import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { persistentStore } from 'services/storage';

export const setSentryUser = (user) => {
  if (user === undefined) {
    user = persistentStore.get('user');
  }
  user && user['id'] && Sentry.setUser({ id: user['id'] });
};

export const initSentry = () => {
  Sentry.init({
    dsn: 'https://d052957291404a248186dc1cbeae207f@o1223753.ingest.sentry.io/6368125',
    integrations: [new BrowserTracing()],
    environment: process.env.NODE_ENV,
    release: 'release_1.4',
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
  setSentryUser();
};
